import React, { useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import cx from "classnames";
import "./Story.scss";
import { Logo } from "../icons/deprecated/Logo";
import { Icon } from "../icons/Icon";
var ANIMATION_DIRECTION;
(function (ANIMATION_DIRECTION) {
    ANIMATION_DIRECTION["BACK"] = "BACK";
    ANIMATION_DIRECTION["FORWARDS"] = "FORWARDS";
})(ANIMATION_DIRECTION || (ANIMATION_DIRECTION = {}));
export const STORY_ANIMATION_DURATION = 600;
export const Story = ({ header, showClose = true, showBack = true, children, progress, onBack, onExit, transitionKey, ariaLabelProgress, ariaLabelBack, ariaLabelClose, }) => {
    const [childIdx, setChildIdx] = useState(null);
    const [animationDirection, setAnimationDirection] = useState(ANIMATION_DIRECTION.FORWARDS);
    let currentChildIdx = null;
    const animationNodeRef = React.useMemo(() => ({ current: null, key: transitionKey }), [transitionKey]);
    React.Children.forEach(children, (child, idx) => {
        if (child !== null) {
            currentChildIdx = child.props.order || idx;
        }
    });
    if (childIdx !== null &&
        currentChildIdx !== null &&
        childIdx < currentChildIdx) {
        setAnimationDirection(ANIMATION_DIRECTION.FORWARDS);
    }
    else if (childIdx !== null &&
        currentChildIdx !== null &&
        childIdx > currentChildIdx) {
        setAnimationDirection(ANIMATION_DIRECTION.BACK);
    }
    if (childIdx !== currentChildIdx) {
        setChildIdx(currentChildIdx);
    }
    const bodyClasses = cx("lysa-story-body", { "animate-back": animationDirection === ANIMATION_DIRECTION.BACK }, { "animate-forward": animationDirection === ANIMATION_DIRECTION.FORWARDS });
    return (React.createElement("section", { className: "lysa-story" },
        React.createElement("header", { className: "lysa-story-header" },
            React.createElement("div", { className: "lysa-story-header-flex-wrapper" },
                React.createElement("div", { className: "lysa-story-header-button" }, showBack ? (React.createElement("button", { type: "button", onClick: onBack, "aria-label": ariaLabelBack },
                    React.createElement(Icon.Back, { size: 24 }))) : null),
                React.createElement("h1", null,
                    header,
                    React.createElement("span", { className: "spacer" }, "|"),
                    React.createElement(Logo, { size: 18, color: "var(--lysa-icon-logo)" })),
                React.createElement("div", { className: "lysa-story-header-button" }, showClose ? (React.createElement("button", { type: "button", onClick: onExit, "aria-label": ariaLabelClose },
                    React.createElement(Icon.Cancel, { size: 24 }))) : null)),
            progress && (React.createElement("div", { className: "lysa-story-progress", "aria-label": ariaLabelProgress(progress) },
                React.createElement("span", { className: "lysa-story-progress-value", style: { width: `${progress}%` } })))),
        React.createElement("div", { className: bodyClasses },
            React.createElement(TransitionGroup, null,
                React.createElement(CSSTransition, { key: transitionKey, timeout: STORY_ANIMATION_DURATION, className: "page-slider", mountOnEnter: true, unmountOnExit: true, nodeRef: animationNodeRef },
                    React.createElement("div", { ref: animationNodeRef }, children))))));
};
